import React from 'react';

const SvgCircleActive = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => (
  <circle
    cx={cx}
    cy={cy}
    r={4}
    fill="#FFF"
    stroke={color}
    strokeLinejoin="square"
    strokeWidth={2}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  />
);

export default SvgCircleActive;
